import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from "../../config/AuthContext";
import { GetInteraccionsAyuda } from "../../dao/GetInteraccionsAyuda";
import UseWebSocketSubscription from "../UseWebSocketSubscription";
import { Badge } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import ChatTableModal from "../jutge/components/ChatTableModal";
import { useNavigate } from "react-router-dom";

const GlobalChatNotification = () => {
    const { isLoggedIn, userId, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [dades, setDades] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [tableVisible, setTableVisible] = useState(false);

    // Initial check
    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [isLoggedIn, userId]);

    // WebSocket subscription
    UseWebSocketSubscription(["/topic/home", "/topic/help"], (topic, msg) => {
        if (msg === true || msg.accion === "REFRESH") {
            checkDades(false);
        }
    });

    async function checkDades(refresh: boolean = true) {
        if (refresh) setLoading(true);
        // Using GetInteraccionsAyuda (lighter) instead of full profile/aules fetch
        const result = await GetInteraccionsAyuda(userId, "0"); // 0 = Global/All Classrooms

        let finalDades = result || [];
        // Apply frontend filter for Admins/Teachers to match ChatTableModal logic
        // Students already filtered by backend procedure
        if (user.tipus === "0" || user.tipus === "1") {
            finalDades = finalDades.filter((d: any) => d.estat === 0);
        }

        setDades(finalDades);
        if (refresh) setLoading(false);
    }

    const notificationCount = dades.length;

    const handleClick = () => {
        setTableVisible(true);
    };

    if (!isLoggedIn) return null;

    return (
        <>
            <div style={{ marginRight: 24, cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={handleClick}>
                <Badge count={notificationCount} size="small" offset={[0, 0]}>
                    <MessageOutlined style={{ fontSize: '20px', color: notificationCount > 0 ? '#faad14' : 'white' }} />
                </Badge>
            </div>

            {tableVisible && (
                <ChatTableModal
                    visible={tableVisible}
                    onClose={() => setTableVisible(false)}
                    aula={{ id: 0 }} // Pass 0 to indicate Global/All fetch if supported by backend
                />
            )}
        </>
    );
};

export default GlobalChatNotification;
